import { Box, Button, Card, CardContent, CardHeader } from "@mui/material";
import { Resource, User } from "../../app/backendTypes";
import { useCatalogBoardingStatus } from "../../app/hooks";
import CatalogAccessButton from "./CatalogAccessButton";
import { BoardingElement, usePendingParts } from "../tools/Tool";
import Loading from "../common/Loading";
import Error from "../common/Error";
import { Fragment } from "react";

export default function CatalogAccessCard(props: {
  resource: Resource;
  user: User;
  resourceLink: string;
}) {
  const { resource, user, resourceLink } = props;

  const { status, loading, error, reload } = useCatalogBoardingStatus(
    resource,
    user.employee.id
  );

  const { element: pendingElement, action: pendingAction } = usePendingParts(
    status?.task_id,
    reload
  );

  const elements = [];
  const actions = [];

  if (loading) elements.push(<Loading />);
  else if (error) elements.push(<Error error={error} />);
  else if (status !== null) {
    elements.push(<BoardingElement status={status} />);

    if (status.value)
      actions.push(
        <Button
          href={resourceLink}
          target="_blank"
          color="secondary"
          variant="outlined"
        >{`Go to ${
          resource.kind === "Tool" ? resource.inner.id : resource.inner.name
        }`}</Button>
      );
    else if (!status.task_id)
      actions.push(
        <CatalogAccessButton
          user={user}
          catalogName={
            resource.kind === "Tool" ? resource.inner.id : resource.inner.name
          }
          catalogId={resource.inner.id}
          callback={reload}
        />
      );

    if (status.task_id) {
      elements.push(pendingElement);
      actions.push(pendingAction);
    }
  }

  return (
    <Card sx={{ width: "100%", maxWidth: "sm" }}>
      <CardHeader
        subheader="Manage access"
        subheaderTypographyProps={{ color: "primary", fontWeight: "bold" }}
      />
      <CardContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          {elements.map((element, i) => (
            <Fragment key={i}>{element}</Fragment>
          ))}
        </Box>

        <br />

        <Box sx={{ display: "flex", gap: 1 }}>
          {actions.map((a, i) => (
            <Fragment key={i}>{a}</Fragment>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
}
